import React, { useState } from 'react';
import BsModal from '../Common/BsModal';

const AlertVerifyEmail = ({show, onClose, email, onConfirm}) => {
    const [verificationCode, setVerificationCode] = useState('');

    const handleChange = (e) => {
        setVerificationCode(e.target.value);
    };

    const handleVerify = () => {
        onConfirm(verificationCode);
        onClose();
    };

    return (
        <BsModal
            show={show}
            onClose={onClose}
            title="Verify Your Email"
            footer={
                <>
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={onClose}
                        >
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleVerify}
                        disabled={verificationCode.length < 4}
                        >
                        <i className="fa fa-check-circle mr-1"></i> Verify Email
                    </button>
               </>
            }
            >
                <p className='text-dark'>
                    Please enter the verification code sent to <i>{email}</i> to verify your account.
                </p>

                <input
                    type="text"
                    className="form-control"
                    id="periodTo"
                    name="closing_date"
                    placeholder="Enter verification code"
                    value={verificationCode}
                    onChange={handleChange}
                    required
                  />
                
        </BsModal>
    );
};

export default AlertVerifyEmail;